import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getAllServices({ commit }, params = {} ) {
    return axios.get(`/services`, { params })
  },
  searchAllServices({ commit }, params = {} ) {
    return axios.get(`/services/search`, { params })
  },
  getServices({ commit }, { supplierId, params = {} } ) {
    return axios.get(`/suppliers/${supplierId}/services`, { params })
  },
  searchServices({ commit }, { supplierId, params = {} } ) {
    return axios.get(`/suppliers/${supplierId}/services/search`, { params })
  },
  getService({ commit }, id) {
    return axios.get(`/services/${id}`)
  },
  createService({ commit }, data) {
    return axios.post('/services', data)
  },
  updateService({ commit }, data) {
    return axios.put(`/services/${data.id}`, data)
  },
}
